/**
 * Las filas del panel de sugerencias, aplanadas (BUS-02).
 *
 * Vive fuera del panel porque la necesitan los dos lados: el panel para pintar
 * cada fila con su indice, y el buscador para saber a donde lleva la que esta
 * marcada cuando se aprieta Enter. El orden de esta lista ES el orden en que se
 * ven, y por eso las flechas del teclado recorren exactamente lo que ve el ojo.
 */
import type { SugerenciasBusqueda } from '@bandu/compartido';

import { rutas } from './rutas';

/** Una fila navegable: su clave y a donde va. */
export interface OpcionSugerida {
  clave: string;
  destino: string;
}

export function opcionesDe(sugerencias: SugerenciasBusqueda): OpcionSugerida[] {
  return [
    ...sugerencias.productos.map((producto) => ({
      clave: `producto-${String(producto.id)}`,
      destino: rutas.producto(producto.slug),
    })),
    ...sugerencias.categorias.map((categoria) => ({
      clave: `categoria-${categoria.slug}`,
      destino: rutas.categoria(categoria.slug),
    })),
    ...sugerencias.marcas.map((marca) => ({
      clave: `marca-${marca}`,
      destino: rutas.busqueda(marca),
    })),
  ];
}
